export default __webpack_public_path__ + "static/media/slider-debt-M.6d6873cb.png";